import React from 'react'
import { Link } from 'react-router-dom'
import probnr from '../../../../assets/img/pdct_bnr.webp'

function Wpw() {
  return (
    <section className='hmslder-sec abt-sec'>
        <div className='breadcrumbs'>
            <div className='container'>
             <ul>
               <li><Link to='/'>Home</Link> </li> 
               <li>Our Products</li>   
             </ul> 
             </div> 
        </div>
        <div className='container'>
           <div className='hmslder-txt'>
              <h2>Innovative <span>digital solutions</span> built to transform the way businesses operate.</h2>
              <p>At 360 Bytes we build digital products that solve real business problems and scale with growth. Our offerings blend clean design, reliable engineering, and thoughtful user experience to deliver measurable value. From SaaS platforms to integrations and APIs, each product is built for performance and ease of use. Explore solutions that accelerate workflows, reduce friction, and help teams move faster.
              </p>
            </div> 
           <div className='hmslder-img'>
            <img src={probnr} alt='Our Products' width={1200} height={600} loading="lazy" />
            </div>  
        </div>
    </section>
  )
}

export default Wpw
